<ion-header class="box-shadow">
  <ion-toolbar>
    <ion-title>Contattaci</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="ion-text-center ion-margin-vertical">
    <ion-label>Contattaci ai seguenti riferimenti:</ion-label>
  </div>
  <div class="ion-text-center ion-margin-vertical">
    <ion-icon name="person" color="primary" style="margin-right: 8px;"></ion-icon>
    <a>Simone Del Buono</a>
  </div>
  <div class="ion-text-center ion-margin-vertical">
    <ion-icon name="call" color="primary" style="margin-right: 8px;"></ion-icon>
    <a href="tel:+393292942969">+39 329 29 42 969</a>
  </div>
  <div class="ion-text-center ion-margin-vertical">
    <ion-icon name="mail" color="primary" style="margin-right: 8px;"></ion-icon>
    <a href="mailto:s.delbuono@digitalevolutionitalia.com">{{'s.delbuono@digitalevolutionitalia.com'}}</a>
  </div>
</ion-content>
